import { FacilityDailyWorkingHours } from '@/types/generated';

import { getDayOfWeekFromDate } from './getDayOfWeek';

import { get12HourTime } from './';

import { DAYS_OF_WEEK, DAYS_OF_WEEK_SHORT_HAND } from '@shared-components/constants';

export const getWorkingHours = (workingHours: FacilityDailyWorkingHours[], isFullName?: boolean) => {
	const hours = workingHours.reduce((acc, cur) => {
		const day = getDayOfWeekFromDate(cur.date as Date);

		if (cur.open?.from === null || cur.open?.to == null) {
			return {
				...acc,
				[day]: 'Closed',
			};
		}

		const startTime = get12HourTime(cur.open.from);
		const endTime = get12HourTime(cur.open.to);
		return {
			...acc,
			[day]: `${startTime} - ${endTime}`,
		};
	}, {} as Record<string, string>);

	const fullWeekHours = DAYS_OF_WEEK.map((fullDayName) => {
		const day = isFullName ? fullDayName : DAYS_OF_WEEK_SHORT_HAND[fullDayName];
		if (hours[fullDayName]) {
			return {
				day,
				hours: hours[fullDayName],
			};
		}
		return {
			day,
			hours: 'Closed',
		};
	});
	return fullWeekHours;
};
